import { isNotEmpty } from 'utils';

export const checkWebsite = (website = '') => {
    if (!isNotEmpty(website)) return;

    const HTTP_KEYWORD = 'http://';

    return website.startsWith(HTTP_KEYWORD) ? website : `${HTTP_KEYWORD}${website}`;
};

export const payerCaseEnums = {
    CLAIM_SUBMISSION: 'CLAIM_SUBMISSION',
    STATUS_INQUIRY: 'STATUS_INQUIRY',
    CLAIM_PAYMENT: 'CLAIM_PAYMENT',
    ELIGIBILITY_CHECK: 'ELIGIBILITY_CHECK',
};

export const clearingHouseTypeEnums = {
    TL_CLEARINGHOUSE: 'TL_CLEARINGHOUSE',
    OFFICE_ALLY: 'OFFICE_ALLY',
    AVAILITY: 'AVAILITY',
};

export const payerCaseEnumList = [
    { title: 'Claim Submission', value: payerCaseEnums.CLAIM_SUBMISSION },
    { title: 'Status Inquiry', value: payerCaseEnums.STATUS_INQUIRY },
    { title: 'Eligibility Check', value: payerCaseEnums.ELIGIBILITY_CHECK },
];
export const payerCapabilitiesEnumList = [
    { title: 'Professional Claim Submission', desc: 'Enrollment Required', value: payerCaseEnums.CLAIM_SUBMISSION },
    { title: 'Eligibility Check', desc: 'Enrollment Required', value: payerCaseEnums.ELIGIBILITY_CHECK },
    { title: 'Claim Status', desc: 'Not Required', value: payerCaseEnums.STATUS_INQUIRY },
    { title: 'Claim Payment', desc: 'Not Required', value: payerCaseEnums.CLAIM_PAYMENT },
];
